import { MenuSearchResult } from './quickSearchMenuSearcher';

export type MenuItem = {
    name: string;
    urlPage: string;
    isHidden?: boolean;
    menu: MenuItem[];
};

// Transform testMenu into quickSearchMenu recursively
const getMenu = (menu: MenuItem) => {
    const transformedMenu: MenuSearchResult[] = [];

    const parse = (item: MenuItem, parent?: MenuItem) => {
        const { name, urlPage, menu: subMenu } = item;
        const parentPrefix = parent && parent.name !== 'HOME' && !parent.isHidden ? `${parent.name} ⯈ ` : '';
        const finalName = `${parentPrefix}${name}`;

        transformedMenu.push({
            title: finalName,
            url: urlPage
        });

        if (subMenu.length) {
            subMenu.forEach((x) => parse(x, item));
        }
    };

    parse(menu);

    return transformedMenu;
};

export default getMenu;
